import { render, staticRenderFns } from "./WeeklyReportRefrigerationPackages.vue?vue&type=template&id=dc5877c0"
import script from "./WeeklyReportRefrigerationPackages.vue?vue&type=script&lang=js"
export * from "./WeeklyReportRefrigerationPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports